import { FunctionComponent } from "react";

import { Breadcrumb, BreadcrumbType, Page } from "@digital-services/shell";

// import { IBreadcrumbs } from "@digital-services/ui/types";
import OrganizationInfo from "@organization/components/OrganizationInfo";
import OrganizationTabMenu from "@organization/components/OrganizationTabMenu";
import { shortenOrgName } from "@organization/utils";

import { useOrganizationContext } from "@hooks/useOrganizationContext";

const OrganizationPage: FunctionComponent = () => {
  const { organization } = useOrganizationContext();

  // @digital-services/shell does not even use Breadcrumbs from <PageContext.Provider>
  const organizationPageBreadcrumbs: Breadcrumb[] = [
    { type: BreadcrumbType.Label, label: "tbd1", path: "/organization/users" },
    {
      type: BreadcrumbType.Label,
      label: "tbd2",
      path: "/organization/api-users"
    }
  ];

  return (
    <Page
      title={shortenOrgName(organization.name)}
      breadcrumbs={organizationPageBreadcrumbs}
    >
      <OrganizationInfo />
      <OrganizationTabMenu />
    </Page>
  );
};

export default OrganizationPage;
